import type { YearDay } from './year-day';
import { DayOfWeek, LocalDate } from '../../../utilities/local-date';

/**
 * Takes a year and a list of holidays
 * Returns a list of days in the year with data for display in calendarium
 */
export function getYearDays(year: string, holidays: { [key: string]: string }) {
  const days: YearDay[] = [];
  const firstDay = LocalDate.fromString(year + '-01-01');
  const firstDayNextYear = firstDay.plusYears(1);
  let day = firstDay;
  let startMinutes = 0;
  while (day.isBefore(firstDayNextYear)) {
    let unitStart = false;
    let today = false;
    const date = day.toString();
    if (day.dayOfWeek() === DayOfWeek.MONDAY || day.day() === 1) {
      unitStart = true;
    }
    if (LocalDate.now().isSame(day)) {
      today = true;
    }
    days.push({
      date: date,
      displayDate: day.day(),
      holiday: holidays[date],
      weekday: day.weekDayOneLetter(),
      displayDateFull: day.weekDayThreeLetters() + ' ' + day.day() + '.',
      unitStart: unitStart,
      today: today,
      startMinutes: startMinutes,
      endMinutes: startMinutes + 1440,
    });
    day = day.plusDays(1);
    startMinutes += 1440;
  }
  return days;
}
